export default __webpack_public_path__ + "static/media/icon_menuarrowup.b96f3cd6.png";